import auth from "../../middlewares/auth";
export const productsRoute = [
  {
    path: '/product/list',
    component: () => import(/* webpackChunkName: "packages" */ '../../views/manage_products/ProductList.vue'),
    name: 'product_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/product/add',
    component: () => import(/* webpackChunkName: "packages" */ '../../views/manage_products/ProductForm.vue'),
    name: 'product_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/product/edit/:id',
    component: () => import(/* webpackChunkName: "packages" */ '../../views/manage_products/ProductForm.vue'),
    name: 'product_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];